<template>
  <span
    class="inline-block cursor-pointer border px-2 py-3 text-neutral-500 first:rounded-l-md last:rounded-r-md hover:border-primary-500 hover:text-primary-500 md:px-4 lg:px-8"
    :class="active ? 'active' : ''"
    @click="emit('click')"
  >
    {{ typeof label === 'function' ? label() : t(label) }}
  </span>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

interface Props {
  name: string;
  label: string | (() => string);
  active: boolean;
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits<{
  (e: 'click'): void;
}>();

const { t } = useI18n();
</script>

<style lang="css" scoped>
/* Workaround for tailwind on active router links */
.active {
  @apply border-primary-500 bg-primary-500 text-neutral-0 !important;
}
</style>
